// Origins we will load executable widget chunks from. The returned base is the
// URL every dynamic `import()` (full-*.js, locale catalogs) resolves against,
// so trusting an untrusted value here is arbitrary code execution on whatever
// origin the entry script runs on. Every real embed points apiUrl at a Worker
// on one of these hosts. Notably `*.workers.dev` is NOT blanket-trusted (anyone
// can deploy a worker there) — only our own account subdomain is.
function isTrustedAssetOrigin(url: URL): boolean {
  const host = url.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "ridestore.org" ||
    host.endsWith(".ridestore.org") ||
    host.endsWith(".ridestore-bff.workers.dev")
  );
}

export function resolveWidgetAssetBase(
  apiUrl: unknown,
  embedScriptUrl: string | undefined,
  pageUrl: string
): string {
  // Untrusted or absent apiUrl falls back to the entry script's own origin —
  // the pre-Worker behavior. A reflected `?apiUrl=` on the public demo can
  // therefore never redirect chunk loading at an attacker origin.
  const fallback = embedScriptUrl ?? pageUrl;
  if (typeof apiUrl !== "string" || !apiUrl.trim()) return fallback;

  try {
    const origin = new URL(apiUrl);
    if (origin.protocol !== "http:" && origin.protocol !== "https:") return fallback;
    if (!isTrustedAssetOrigin(origin)) return fallback;
    return new URL("/ridestore-chat.js", origin).href;
  } catch {
    return fallback;
  }
}
